//All End point here

//Instructor
export const instructor = 'instructor';
export const one_to_one = 'one-to-one';
export const one_to_many = 'one-to-many';
export const accessLog = 'access-log';
export const instructorPresentEndPoint = 'instructor-present';

export const live = 'live';

//courses
export const courses = 'courses';
export const nextLive = 'next-live';

//Auth
export const login = 'login';




